import * as React from "react"
import PropTypes from "prop-types"
// import { Link } from "gatsby"
import CraftImage from "../craftcms/craft-image"
// import './hero-wrap.scss';
// import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import "./hero-feature-story.scss"
import ArticleTags from "./article-tags"

// http://staging-static.vmhost.psu.edu/components/non-homepage-hero-short-standard.php

const HeroFeatureStory = ({
  image,
  subheading,
  children,
  title,
  sectionHandle,
  sectionOverride,
  tags,
}) => {
  /* section title isn't currently coming from craft graphql so put a space in front of camel case letters */
  let section = ""
  if (typeof sectionHandle !== "undefined")
    section = sectionHandle.replace(/([A-Z])/, " $1")
  if (typeof sectionHandle !== "undefined" && sectionHandle === "pages")
    section = ""
  if (typeof sectionOverride !== "undefined" && sectionOverride !== null)
    section = sectionOverride

  console.log("section: ", section)

  return (
    <header
      className="feature-story-hero-module__featureStoryHero"
      data-testid="feature-story-hero"
    >
      <div className="feature-story-hero-module__wrapper">
        <div className="feature-story-hero-module__media">
          {/* <img
					itemprop="contentUrl"
					content="https://source.unsplash.com/NIJuEQw0RKg/2000x1500"
					className="feature-story-hero-module__image image-module__image"
					loading="lazy"
					src="https://source.unsplash.com/NIJuEQw0RKg/1000x750"
					srcset="https://source.unsplash.com/NIJuEQw0RKg/88x88 88w, https://source.unsplash.com/NIJuEQw0RKg/250x188 250w, https://source.unsplash.com/NIJuEQw0RKg/500x375 500w, https://source.unsplash.com/NIJuEQw0RKg/1000x750 1000w, https://source.unsplash.com/NIJuEQw0RKg/1500x1125 1500w, https://source.unsplash.com/NIJuEQw0RKg/2000x1500 2000w"
					sizes="(min-width: 1080px) 1440px, 720px"
					alt="Some books"
					data-testid="image"
				/> */}
          {/* {typeof image[0] !== 'undefined' ? ( */}
          <CraftImage
            {...image[0]}
            className="feature-story-hero-module__image image-module__image"
          />
          {/* ) : (
					<span>image[0]: {image[0]}</span>
				)} */}
        </div>
        <div className="feature-story-hero-module__content">
          <span
            className={`feature-story-hero-module__topic ${
              section === "" ? "d-none" : ""
            }`}
          >
            {section}
          </span>
          <h2 className="feature-story-hero-module__title">{title}</h2>
          <p className="feature-story-hero-module__description">{subheading}</p>
        </div>
        {typeof tags !== "undefined" ? (
          <ArticleTags tags={tags} className="tag-light" />
        ) : (
          ""
        )}
      </div>

      {/* <div className="feature-story-hero-module__captionContainer">
			<figcaption
				className="caption-module__caption caption-module__captionExpanded feature-story-hero-module__caption"
				data-testid="caption"
			>
				<div className="caption-module__wrapper">
					<div className="caption-module__captionContentWrapper caption-background">
						<div className="caption-module__captionContent caption-module__captionContentExpanded">
							<p>
								<span>
									Lorem ipsum dolor sit amet, consectetur
									adipiscing elit, sed do eiusmod tempor
									incididunt ut labore et dolore magna aliqua.
									Ut enim ad minim veniam, quis nostrud
									exercitation ullamco laboris nisi ut aliquip
									ex ea commodo consequat. Duis aute irure
									dolor in reprehenderit in voluptate velit
									esse cillum dolore eu fugiat nulla pariatur.
								</span>
								&nbsp;
								<span
									className="caption-module__captionCredit"
									data-testid="credit"
								>
									Credit: Patrick Mansell. All rights
									reserved.
								</span>
							</p>
						</div>
					</div>
					<button>Collapse</button>
				</div>
			</figcaption>
		</div> */}
    </header>
  )
}

HeroFeatureStory.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  children: PropTypes.node,
  image: PropTypes.array,
}

HeroFeatureStory.defaultProps = {
  heading: `Explore`,
  subheading: `systems and components that make up modern dairy`,
  children: <p></p>,
  image: [
    {
      extension: "jpg",
      filename: "150-farm.jpg",
      focalPoint: [0.5, 0.5],
      hasFocalPoint: false,
      path: "150-farm.jpg",
      title: "150 farm",
      width: 3840,
      url: "//virtual-farm:8890/uploads/150-farm.jpg",
      srcset:
        "//virtual-farm:8890/uploads/_600xAUTO_crop_center-center_none/150-farm.jpg 600w, //virtual-farm:8890/uploads/_900xAUTO_crop_center-center_none/150-farm.jpg 900w, //virtual-farm:8890/uploads/_1200xAUTO_crop_center-center_none/150-farm.jpg 1200w, //virtual-farm:8890/uploads/_1500xAUTO_crop_center-center_none/150-farm.jpg 1500w, //virtual-farm:8890/uploads/_1800xAUTO_crop_center-center_none/150-farm.jpg 1800w",
    },
  ],
}

export default HeroFeatureStory
